import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Autocomplete, Radio, RadioGroup, FormControlLabel, FormLabel, TextareaAutosize,
    Typography
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import styled, { cutDates, inputStyles, stockNumber, inputNumbersmall, inputStyle11 } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { selectFirm, selectItems, selectParty } from '../Selectors/Master/ItemSelectors';
import axios from 'axios';
import Dropdown from '../FieldsComponents/Dropdown';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import DateInputComponent2 from '../FieldsComponents/DateInputComponent2';
import Preview from '@mui/icons-material/Preview';
import PreviewIcon from '@mui/icons-material/Preview';
import DeleteIcon from '@mui/icons-material/Delete';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { fetchPartyData } from '../../Store/PHPSlice/Party';
import { fetchItemData } from '../../Store/PHPSlice/Item';
import { adminStkInwMenu, StkInwMenu, UStkInwMenu } from '../TitleList';
import RadioComponent from '../FieldsComponents/RadioComponent';
import { insertUserStkInwEntry } from '../../Store/PHPSlice/StkInw';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { fetchLocationData } from '../../Store/PHPSlice/LocationApi';
import { selectLocations } from '../Selectors/Master/OutwardSelectors';

const UStkInwEntry = () => {

    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [selectedRows, setSelectedRows] = useState(new Set());
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        stk_type: 'Bill Wise',
        firmId: '',
        partyId: '',
        schlId: '',
        memo: '',
        item: '',
        size: '',
        col: '',
        qnty: '',
        saleRt: '',
        purRt: '',
        totQty: '0',
        totprate: '0',
        totsrate: '0',
        totdisrate: '0',
        totdisrate2: '0',
        totQty2: '0',
        totdisamt: '0',
        totdisamt2: '0',
        totprate2: '0',
        totsrate2: '0',
        totamt: '0',
        totamt2: '0',
        freight_ch: '0',
        other_ch: '0',
        grandtot: '',
        gst_type: 'no',
        gst: '5',
        igst: '0',
        cgst: '0',
        sgst: '0',
        state_type: '',
        discnt_type: 'percent',
        discnt_amt: '',
        discnt_val: '0',
        netamt: '',
        billNo: '',
        type: '',
        userId: userdata?.ID
    });
    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        // Add more mappings if needed
    };
    const [userData, setUserData] = useState(null);

    const [tableData, setTableData] = useState([]);
    const [multiItems, setMultiItems] = useState([]);
    const [billList, setBillList] = useState([]);
    const [schlList, setSchlList] = useState([]);
    const [items, setItems] = useState([]);
    const [selectData, setSelectData] = useState([]);
    const [activeMenu, setActiveMenu] = useState(StkInwMenu);
    const dispatch = useDispatch();

    const itemList = useSelector(selectItems);
    const firmlist = useSelector(selectFirm);
    const allschls = useSelector(selectLocations);

    useEffect(() => {
        dispatch(fetchItemData());
        dispatch(fetchCompanyData());
        dispatch(fetchLocationData());
        fetchUserStkMemo();
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        const user = sessionStorage.getItem('user');
        if (user) {
            setUserData(JSON.parse(user));
        }
    }, []);

    useEffect(() => {
        if (!userdata) return;
        // console.log(userdata)
        if (userdata?.udata) {
            const val = userdata?.ID;
            fetchBillNosSchlwise({ userId: val });
            setFormData(prev => ({
                ...prev,
                type: 'userId'
            }));
        } else if (userdata?.role === '1') {
            setFormData(prev => ({
                ...prev,
                type: 'userId'
            }));
        }

        if (userdata?.pageIds?.length > 0 && userdata?.role !== '1') {
            const pid = userdata?.pageIds?.find(item => item === 1);
            if (pid === 1 && userdata?.role === '3') {
                setActiveMenu(adminStkInwMenu);
            } else if (userdata?.role === '2') {
                setActiveMenu(UStkInwMenu);
            } else {
                setActiveMenu(StkInwMenu);
            }

            const selectpid = userdata?.pageIds?.filter(item => item === 1 || item === 2);
            if (selectpid?.length > 0) {
                const data = {
                    uid: userdata?.ID,
                    pageId: selectpid
                };
                fetchPageAssignSchools(data);
            }
        }

    }, []);
    console.log(userdata)


    const fields2 = [
        { label: 'Total Quantity', name: 'totQty', type: 'readOnly' },
        { label: 'Discount %', name: 'discnt_val', type: 'readOnly' },
        { label: 'Total Sale Rate', name: 'totsrate', type: 'readOnly' },
        { label: 'Total Discount Rate', name: 'totdisrate', type: 'readOnly' },
        { label: 'Total Amount', name: 'totdisamt', type: 'readOnly' },
    ];


    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleViewClick = (form) => {
        // Construct the URL with query parameters or use a placeholder route
        const url = `/user-stock-inward-view?form=${encodeURIComponent(JSON.stringify(form))}`;

        // Open the URL in a new tab
        window.open(url, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        switch (dropdownType) {
            case 'item':
                if (value) {
                    const selectInfo = items?.find(val => val.ID === value);
                    const filterData = items?.filter((val) => val.ID !== value);
                    setTableData(prev => [...prev, selectInfo]);
                    setItems(filterData);
                }
                break;
            case 'billNo':
                if (value) {
                    fetchItems(value);
                } else {
                    setTableData([]);
                    setFormData(prev => ({
                        ...prev,
                        totQty: '0',
                        totQty2: ''
                    }))
                }
                break;
            case 'schlId':
                if (value) {
                    fetchBillNosSchlwise({ schlId: value });
                }
                break;
            case 'discnt_val':
                if (value) {
                    let totalAmount = parseFloat(formData.totamt);
                    let discnt_amt, grandtot;
                    let other_ch = formData.other_ch !== '' ? parseFloat(formData.other_ch) : 0;
                    let freight_ch = formData.freight_ch !== '' ? parseFloat(formData.freight_ch) : 0;
                    if (formData.discnt_type == 'percent') {
                        discnt_amt = Math.round(totalAmount / parseFloat(value));
                        grandtot = totalAmount - discnt_amt + other_ch + freight_ch;
                    } else if (formData.discnt_type == 'rupees') {
                        discnt_amt = parseFloat(value);
                        grandtot = totalAmount - discnt_amt + other_ch + freight_ch;
                    }

                    let igst = 0, cgst = 0, sgst = 0;
                    let cal_grand = Math.round(parseFloat(grandtot) / parseFloat(formData.gst));
                    if (formData.state_type == '1') {
                        igst = cal_grand;
                    } else {
                        const half_grand = (cal_grand / 2).toFixed(2);
                        cgst = half_grand;
                        sgst = half_grand;
                    }
                    let final_grand_tot = Math.round(parseInt(grandtot, 10) + parseInt(cal_grand, 10));
                    setFormData(prev => ({
                        ...prev,
                        discnt_amt: discnt_amt,
                        grandtot: grandtot,
                        igst: igst || 0,
                        cgst: cgst || 0,
                        sgst: sgst || 0,
                        netamt: final_grand_tot
                    }));
                }
                break;
            default:
                break;
        };
    };


    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleChange = (index, field, value) => {
        const updatedData = [...tableData];

        if (field === 'qty') {
            const prevQty = parseFloat(updatedData[index][field] || 0);
            const newQty = parseFloat(value || 0);
            const prate = parseFloat(updatedData[index].prate || 0);
            const amt = newQty * prate;
            // Update the quantity first
            updatedData[index][field] = newQty;
            updatedData[index].amt = amt;
            setTableData(updatedData);
            // Update the total quantity
            setFormData(prev => ({
                ...prev,
                totQty: parseFloat(prev.totQty) - prevQty + newQty,
                totQty2: parseFloat(prev.totQty2) - prevQty + newQty,
            }));
        }

        if (field === 'prate') {
            const prevPrate = parseFloat(updatedData[index][field] || 0);
            const newPrate = parseFloat(value || 0);
            const qty = parseFloat(updatedData[index].qty || 0);
            const amt = qty * newPrate;
            // Update the quantity first
            updatedData[index][field] = newPrate;
            updatedData[index].amt = amt;
            setTableData(updatedData);
            const totprate = multiItems?.reduce((acc, sum) => acc + parseFloat(sum.totprate), 0);
            // Update the total quantity
            setFormData(prev => ({
                ...prev,
                totprate: parseFloat(prev.totprate) - prevPrate + newPrate,
                totprate2: parseFloat(prev.totprate2) - prevPrate + newPrate,
            }));
        }

        if (field === 'srate') {
            const prevSrate = parseFloat(updatedData[index][field] || 0);
            const newQSrate = parseFloat(value || 0);

            // Update the quantity first
            updatedData[index][field] = newQSrate;
            setTableData(updatedData);
            const totsrate = multiItems?.reduce((acc, sum) => acc + parseFloat(sum.totsrate), 0);

            // Update the total quantity
            setFormData(prev => ({
                ...prev,
                totsrate: parseFloat(prev.totsrate) - prevSrate + newQSrate,
                totsrate2: parseFloat(prev.totsrate2) - prevSrate + newQSrate,
            }));
        }

        if (field === 'color') {
            updatedData[index][field] = value;
            setTableData(updatedData);
        }


        if (field === 'salerate') {
            updatedData[index][field] = value;
            setTableData(updatedData);
        }
        if (field === 'issqty') {
            const bqty = parseFloat(updatedData[index].bqty);
            const issqty = parseFloat(value);

            if (issqty <= bqty) {
                const balqty = bqty - issqty;
                updatedData[index][field] = value;
                updatedData[index].balqty = balqty;
                setTableData(updatedData);
            } else {
                alert("Issued quantity cannot be greater than balance quantity.");
            }
        }

    };


    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };


    const fetchPageAssignSchools = async (id) => {
        const { uid, pageId } = id;
        try {
            const response = await axios.get(`${baseUrl}?apicall=getUserwisePageIdSchools&uid=${uid}&pageId=${pageId}`);
            setSchlList(response?.data?.data);
            // console.log(response.data)

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    // console.log(multiItems);

    const fetchUserStkMemo = async () => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getSchlStkMemo`);
            const memos = response?.data?.data;
            setFormData(prev => ({
                ...prev,
                memo: memos?.memo
            }));
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchBillNosSchlwise = async ({ userId, schlId }) => {
        try {
            let endpoint = `getSchlWiseBills`;
            if (userId) {
                endpoint = `getSchlWiseBills&userId=${userId}`;
            } else if (schlId) {
                endpoint = `getSchlWiseBills&schlId=${schlId}`;
            }
            const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
            // console.log(`${baseUrl}?apicall=${endpoint}`)
            if (userId) {
                setSchlList(response?.data?.data);
            } else if (schlId) {
                setBillList(response?.data?.data);
            }
            // console.log(response.data);

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const fetchItems = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getAdminSaleEntry&sId=${id}`);
            setSelectData(response?.data);
            setTableData(response.data.info);
            const val = response.data.data;
            // console.log(val);

            const totsrate = response?.data?.info?.reduce((acc, sum) => acc + parseFloat(sum.srate), 0);
            const totdisrate = response?.data?.info?.reduce((acc, sum) => acc + parseFloat(sum.disrate), 0);
            const totdisamt = response?.data?.info?.reduce((acc, sum) => acc + parseFloat(sum.disamt), 0);

            const itemid = response?.data?.info?.length > 0 ? response?.data?.info[0]?.itemId : '0';
            setFormData(prev => ({
                ...prev,
                totQty: parseFloat(prev.totQty) + parseFloat(val.totissqty),
                totQty2: parseFloat(val.totissqty),
                // totamt: val.totamt,
                // gst: val.gst_val,
                // gst_type: val.gst,
                // freight_ch: val.freight_ch,
                // other_ch: val.other_ch,
                discnt_amt: val.discnt_amt,
                // discnt_type: val.discnt_type,
                discnt_val: val.discnt_val,
                netamt: val.netamt,
                grandtot: val.netamt,
                // igst: val.igst,
                // cgst: val.cgst,
                // sgst: val.sgst,
                item: itemid,
                firmId: val.firmId,
                totdisamt2: totdisamt,
                totsrate2: totsrate,
                totdisrate2: totdisrate

            }));
            const filterBills = billList?.filter((val) => val.ID !== id);
            setBillList(filterBills);
            // console.log(response.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
            setTableData([]);
        }
    };
    // console.log(formData.billNo)
    const dropdownOrdType = [
        {
            label: 'Firm',
            id: 'firmId',
            options: firmlist?.data || [],
            value: formData.firmId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        },
        {
            label: 'Bill No',
            id: 'billNo',
            options: billList || [],
            value: formData.billNo,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'billNo', value: newValue ? newValue.ID : '' } }, 'billNo'),
            getOptionLabel: (option) => option.billNo || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        },
        // {
        //     label: 'Item',
        //     id: 'item',
        //     options: items || [],
        //     value: formData.item,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'item', value: newValue ? newValue.ID : '' } }, 'item'),
        //     getOptionLabel: (option) => option.itemNm || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        //     bold: true
        // }
    ];
    // console.log(schlList)
    const dropdownOrdType2 = [
        {
            label: 'Firm',
            id: 'firmId',
            options: firmlist?.data || [],
            value: formData.firmId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firmId', value: newValue ? newValue.ID : '' } }, 'firmId'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        },
        {
            label: 'School',
            id: 'schlId',
            options: userdata?.role !== '1' ? schlList : allschls?.data || [],
            value: formData.schlId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'schlId', value: newValue ? newValue.ID : '' } }, 'schlId'),
            getOptionLabel: (option) => option.schlcd || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        },
        {
            label: 'Bill No',
            id: 'billNo',
            options: billList || [],
            value: formData.billNo,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'billNo', value: newValue ? newValue.ID : '' } }, 'billNo'),
            getOptionLabel: (option) => option.billNo || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true
        }

    ];


    const handleMultiItems = () => {
        const itemnm = itemList?.data?.find(val => val.ID === formData.item)?.itemNm;
        const totsalerate = tableData?.reduce((acc, sum) => acc + parseFloat(sum.srate), 0);
        const totdisrate = tableData?.reduce((acc, sum) => acc + parseFloat(sum.disrate), 0);
        const totdisamt = tableData?.reduce((acc, sum) => acc + parseFloat(sum.disamt), 0);
        const data = {
            info: tableData,
            itemNm: itemnm,
            itemId: formData.item,
            totqty: formData.totQty2,
            adsaleid: formData.billNo,
            totsrate: totsalerate,
            totdisrate: totdisrate,
            totdisamt: totdisamt
        };
        setMultiItems(prev => [...prev, data]);
        setTableData([]);
        setFormData(prev => ({
            ...prev,
            totQty2: '',
            billNo: '',
            totsrate: parseFloat(prev.totsrate) + totsalerate,
            totdisrate: parseFloat(prev.totdisrate) + totdisrate,
            totdisamt: parseFloat(prev.totdisamt) + totdisamt,
            totdisamt2: '0',
            totsrate2: '0',
            totdisrate2: '0'
        }));
    };

    const handleCheckboxChange = (index) => {
        setSelectedRows(prevSelectedRows => {
            const newSelectedRows = new Set(prevSelectedRows);
            if (newSelectedRows.has(index)) {
                newSelectedRows.delete(index);
            } else {
                newSelectedRows.add(index);
            }
            return newSelectedRows;
        });
    };

    const handleRemoveSelected = () => {
        const filterData = multiItems?.filter((_, index) => selectedRows.has(index));
        // console.log(filterData)
        const totqty = filterData?.reduce((acc, sum) => acc + parseFloat(sum.totqty), 0);
        const totsrate = filterData?.reduce((acc, sum) => acc + parseFloat(sum.totsrate), 0);
        const totdisrate = filterData?.reduce((acc, sum) => acc + parseFloat(sum.totdisrate), 0);
        const totdisamt = filterData?.reduce((acc, sum) => acc + parseFloat(sum.totdisamt), 0);
        // console.log(totqty);
        setFormData(prev => ({
            ...prev,
            totQty: parseFloat(prev.totQty) - parseFloat(totqty),
            totQty2: '0',
            totsrate: parseFloat(prev.totsrate) - parseFloat(totsrate),
            totsrate2: '0',
            totdisrate: parseFloat(prev.totdisrate) - parseFloat(totdisrate),
            totdisrate2: '0',
            totdisamt: parseFloat(prev.totdisamt) - totdisamt,
            totdisamt2: '0'
        }));

        setMultiItems(prevFormArray =>
            prevFormArray.filter((_, index) => !selectedRows.has(index))
        );
        setSelectedRows(new Set()); // Clear selection after removal
    };



    function convertIntoOneObject(formData, multiItems) {

        const data = {
            dt: formData.dt,
            memo: formData.memo,
            firmId: formData.firmId,
            party: formData.partyId,
            schlId: formData.schlId,
            multiItems: multiItems,
            discnt_val: formData.discnt_val,
            totqty: formData.totQty,
            totsrate: formData.totsrate,
            totdisrate: formData.totdisrate,
            totdisamt: formData.totdisamt,
            userId: formData.userId,
            stk_type: formData.stk_type,
            adsid: formData.billNo
        };
        return data;
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        if (formData.firmId === '') {
            alert('Please Select Firm');
            return; // Stop form submission
        };

        const finalObj = convertIntoOneObject(formData, multiItems);
        // console.log(finalObj);

        dispatch(insertUserStkInwEntry(finalObj))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Stock Inward Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };
    // console.log(tableData)
    return (
        <>
            {/* <Titlebar data={userdata?.role === '2' ? UStkInwMenu : StkInwMenu} /> */}
            <Titlebar data={activeMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Stock Inward</h2>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Memo No', name: 'memo', type: 'readOnly' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.cutDate }}
                                                            sx={cutDates}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type }}
                                                            sx={cutDates}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}



                                {
                                    formData.type === 'schlId' && dropdownOrdType?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here

                                        />
                                    ))
                                }

                                {
                                    formData.type === 'userId' && dropdownOrdType2?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here

                                        />
                                    ))
                                }

                                {fields2.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}







                                {Array.isArray(tableData) && tableData.length > 0 &&
                                    <>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow className='tbl-row'>
                                                        {/* <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Select.</TableCell> */}
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Item</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Size</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Color</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Stock Qty</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Sale Rate</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Discount Rate</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Amt</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableData.length > 0
                                                        ? tableData?.map((form, index) => (
                                                            <TableRow key={index}>
                                                                {/* <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                    <Checkbox
                                                                        checked={selectedRows?.has(index)}
                                                                        onChange={() => handleCheckboxChange(index)}
                                                                    />
                                                                </TableCell> */}
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.itemNm}</TableCell>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.size}</TableCell>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.color}</TableCell>

                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.bqty}</TableCell>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.srate}</TableCell>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.disrate}</TableCell>
                                                                <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.disamt}</TableCell>
                                                                {/* <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                    <input type="text"
                                                                        value={form.salerate || ''}
                                                                        name='salerate'
                                                                        onChange={(e) => handleChange(index, 'salerate', e.target.value)}
                                                                        style={{ height: '25px', width: '60px' }}
                                                                    />
                                                                 
                                                                </TableCell> */}
                                                            </TableRow>
                                                        ))
                                                        : ''}
                                                    <TableRow>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'></TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'></TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'></TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>Total</TableCell>

                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{formData.totQty2}</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{formData.totsrate2}</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{formData.totdisrate2}</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{formData.totdisamt2}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </TableContainer>


                                        <Grid item xs={12} textAlign="center" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                            <Button variant="contained" color="primary" onClick={handleMultiItems}>Add</Button>

                                        </Grid>
                                    </>
                                }

                                <Button variant="contained" color="primary" onClick={handleRemoveSelected}>Delete</Button>

                                <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                    <Table>
                                        <TableHead>
                                            <TableRow className='tbl-row'>
                                                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Select.</TableCell>
                                                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Item</TableCell>
                                                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Total Qty</TableCell>
                                                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Total Sale Rate</TableCell>
                                                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Total Discount Rate</TableCell>
                                                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>Total Amount</TableCell>
                                                <TableCell sx={{ p: 0.2, border: '1px solid #000' }} align='center'>View</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {multiItems.length > 0
                                                ? multiItems?.map((form, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                            <Checkbox
                                                                checked={selectedRows?.has(index)}
                                                                onChange={() => handleCheckboxChange(index)}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.itemNm}</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.totqty}</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.totsrate}</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.totdisrate}</TableCell>
                                                        <TableCell sx={{ p: 0.2, border: '1px solid #000', fontSize: '15px' }} align='center'>{form.totdisamt}</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                            <PreviewIcon className='cursor-pointer' onClick={() => handleViewClick(form)} />
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                                : ''}
                                        </TableBody>
                                    </Table>
                                </TableContainer>


                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>

                                </Grid>
                            </Grid>
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default UStkInwEntry;
